import { createTheme, ThemeOptions } from "@mui/material/styles";

export const Colors: { [key: string]: string } = {
  primaryColor: "rgb(0, 0, 0)",
  secondaryColor: "#656d6b",
  white: "rgba(255,255,255,1)",
  black: "#000000",
  dark: "rgba(100,100,100,1)",
  default: "#a9a9a9",
  success: "#4caf50",
  info: "#2196f3",
  error: "#b61827",
  warning: "#ff9800",
};

export const theme = createTheme({
  typography: {
    button: {
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: Colors.primaryColor,
    },
    secondary: {
      main: Colors.secondaryColor,
    },
    error: {
      main: Colors.error,
    },
    warning: {
      main: Colors.warning,
    },
    text: {
      primary: Colors.black,
    },
  },
} as ThemeOptions);
